import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: buttonSize => ({
      height: buttonSize + 1,
      width: buttonSize + 1,
      borderRadius: 8,
    }),
    buttonContainer: buttonSize => ({
      backgroundColor: colors.surface,
      height: buttonSize,
      width: buttonSize,
      borderRadius: 8,
      padding: 4,
      alignItems: 'center',
      justifyContent: 'center',
    }),
  });

export default makeStyles;
